import axios from 'axios';
import miscFunctions from '../helpers/misc-functions';
import apiRecordLayoutFunctions from '../helpers/apiRecordLayoutFunctions.js';
import { project_partial } from '../helpers/apiRecordLayoutFunctions.js';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';
import DataModel from '../models/DataModel.js';

const NO_PROJECT_SET_ERROR = 'Project not set';

let helpers = {
  getProjects(company_id, page, perPage, options) {
    let request = null;
    if (page) {
      request = process.env.REACT_APP_API + '/projects?current_company=' + localStorage.current_company_id + '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }
    else {
      request = process.env.REACT_APP_API + '/projects?current_company=' + localStorage.current_company_id;
    }

    if (options && options.recordDescriptor) {
      //added this for now so we can descriminate between old and new calls
      request += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    else{
      request += '&filtering=' + apiRecordLayoutFunctions.getEncodedRecordLayout(project_partial);
    }
    return axios({
      method: 'get',
      url: request,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  getProjectsByIds(projectIds, options, location_id) {
    let request = process.env.REACT_APP_API + '/projects?current_company=' + localStorage.current_company_id;

    if (projectIds && projectIds.length > 0) {
      request += '&project_ids=' + projectIds.join();
    }
    if (location_id) {
      request += '&location_id=' + location_id;     
    }
    if (options && options.recordDescriptor) {
      request += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: request,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  getUserProjects(page, perPage, user, company_id, searchString, orderBy, ascending = false, options = {}) {
    let url = null;
    if (page && perPage) {
      url = process.env.REACT_APP_API + '/projects/all_assigned_projects?current_company=' + (company_id ? company_id : localStorage.current_company_id) + (user ? '&user_id=' + user.id : '') + '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }
    else {
      url = process.env.REACT_APP_API + '/projects/all_assigned_projects?current_company=' + (company_id ? company_id : localStorage.current_company_id) + (user ? '&user_id=' + user.id : '');
    }
    if (searchString) {
      url += '&keywords=' + searchString; 
    }
    if (orderBy) {
      url += '&order=' + orderBy + (ascending ? ',asc' : ',desc');
    }
    if (options.ignoreCompleted) {
      url += '&ignore_completed=true';
    }

    if (options && options.recordDescriptor) {
      //added this for now so we can descriminate between old and new calls
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'get',
      url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        let data=response.data;
        localStorage.setItem('favorite_projects',data.meta.total_favorite_projects);
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getFavorites(user_id, options) {
    let url = process.env.REACT_APP_API + '/projects/favorites?current_company=' + localStorage.current_company_id; 
    if (options && options.recordDescriptor) {
      //added this for now so we can descriminate between old and new calls
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    if (options && options.assigned) {
      url += '&assigned=true';
    }
    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getFavoritesNav(user_id, options) {
    let url = process.env.REACT_APP_API + '/projects/favorites_nav?current_company=' + localStorage.current_company_id; 
    if (options && options.recordDescriptor) {
      //added this for now so we can descriminate between old and new calls
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    if (options && options.assigned) {
      url += '&assigned=true';
    }
    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getProject(projectId, company_id, options) {
    if (!projectId) {
      return Promise.reject({ error: NO_PROJECT_SET_ERROR });
    }
    let url = process.env.REACT_APP_API + '/projects/' + projectId + '?current_company=' + (company_id ? company_id : localStorage.current_company_id); 
    if (options && options.include_location_builds) {
      url += '&include_location_builds=true';
    }
    else if (options && options.include_location_documents) {
      url += '&include_location_documents=true';
    }
    if (options && options.location_id && options.location_id != 'all') {
      url += '&location_id=' + options.location_id;     
    }
    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });

  },
  getLocationProject(projectId, company_id, options) {
    if (!projectId) {
      return Promise.reject({ error: NO_PROJECT_SET_ERROR });
    }
    let url = process.env.REACT_APP_API +
    '/projects/' +
    projectId +
    '/show_for_location_projects?current_company=' +
    (company_id ? company_id : localStorage.current_company_id);

    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });

  },
  getProjectsForLocation(location_id, searchString, filter = null, options) {
    if (!location_id) {
      return Promise.reject({ error: NO_PROJECT_SET_ERROR });
    }
    let url = process.env.REACT_APP_API +
      '/locations/' +
      location_id +
      '/location_projects?current_company=' + localStorage.current_company_id +
      (searchString ? ('&keywords=' + searchString) : '');
    
    if (!miscFunctions.isEmpty(filter)) {
      url += '&state=' + (filter.state || '');
      if (filter.project_types) {
        let projectTypes = '&project_type=' + filter.project_types.map(pt => encodeURIComponent(pt.id)).join(',');
        url += projectTypes;
      }
      else if (filter.project_type) {
        let projectType = '&project_type=' + filter.project_type.id;
        url += projectType;
      }
      if (filter.projectEventType && (filter.startDate || filter.endDate)) {
        let sDate = new Date(filter.startDate).toUTCString();
        let eDate = new Date(filter.endDate).toUTCString();
  
        let utcStart = Date.parse(sDate);
        let utcEnd = Date.parse(eDate);
        utcEnd += 24 * 60 * 60 * 1000 - 1;
  
        let offset = (new Date().getTimezoneOffset() * 60 * 1000);
  
        utcStart += offset;
        utcEnd += offset;
  
        url += filter.startDate ? `&start_date=${Math.floor(utcStart / 1000)}` : '';
        url += filter.endDate ? `&end_date=${Math.floor(utcEnd / 1000)}` : '';
  
        url += '&date_column=' + (filter.projectEventType == 'completed' ? 'completed_dtm' : 'create_dtm');
      }
  
      if (filter.statuses) {
        let statuses = filter.statuses.map(status => {
          switch (status) {
          case 'not_started':
            return 'Not Started';
          case 'in_progress':
            return 'In Progress';
          case 'complete':
            return 'Complete';
          default:
            return '';
          }
        });
        url += '&status=' + statuses.join(',');
      }
    }

    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });

  },  getFlatProject(projectId, company_id) {
    if (!projectId) {
      return Promise.reject({ error: NO_PROJECT_SET_ERROR });
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/projects/' + projectId +
        '?current_company=' + (company_id ? company_id : localStorage.current_company_id), 
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });

  },

  getAllContractIds(company_id){

    let url = process.env.REACT_APP_API + '/projects/contract_ids?current_company=' + (company_id ? company_id : localStorage.current_company_id);
    
    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },

  getUserProject(projectId, company_id, tasks_count, options) {
    if (!projectId) {
      return Promise.reject({ error: NO_PROJECT_SET_ERROR });
    }
    let url = process.env.REACT_APP_API + '/tasks/all_assigned_tasks_by_project?project=' +
    projectId + '&current_company=' + (company_id ? company_id : localStorage.current_company_id);
    
    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    if (tasks_count) {
      url += '&page=1&per=' + tasks_count;
    }
    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });

  },
  createProject(project, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    project.location_id = project.location ? project.location.id : project.location_id;
    project.project_manager_id = project.project_manager ? project.project_manager.id : project.project_manager_id;
    project.company_id = localStorage.current_company_id;
    delete project.id;
    delete project.location;
    delete project.project_manager;
    delete project.custom_project_settings;
    delete project.created_at;
    delete project.updated_at;
    delete project.deleted_at;
    delete project.archived_at;
    if (project.project_type == null){
      delete project.project_type;
    }
    if (project.guid == null){
      delete project.guid;
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/projects?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        project: project,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateProject(projectToSave, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    let project = Object.assign({}, projectToSave);
    project.market_id = project.market ? project.market.id : project.market_id;
    project.location_id = project.location ? project.location.id : project.location_id;
    project.project_manager_id = project.project_manager ? project.project_manager.id : project.project_manager_id;
    project.project_group_id = project.project_group ? project.project_group.id : project.project_group_id;
    delete project.root_build.builds;
    delete project.location;
    delete project.project_manager;
    delete project.custom_project_settings;
    delete project.market;
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        project: project,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteProject(project_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/projects/' + project_id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return { status: 'success' };
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  archiveProject(project_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/projects/' + project_id + '/archive?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  unarchiveProject(project_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/projects/' + project_id + '/unarchive?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  copyProject(fromProject, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/projects/' + fromProject.id + '/copy?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createOfflineProject(project, eventMetaDatum, options) {

    let metaDatumEvent = eventMetaDatum;
    if (!eventMetaDatum) {
      metaDatumEvent = Metadata.generateMetadatum(); 
      
    }
    
    let url = process.env.REACT_APP_API + '/projects/' + project.id + '/add_offline_project?current_company=' + localStorage.current_company_id;
    if(options && options.recordDescriptor){
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'post',
      url: url,
      data: {
        eventMetaDatum: metaDatumEvent,
        favorite_id: project.id,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  deleteOfflineProject(project_id, eventMetadatum){
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }

    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/projects/' + project_id + '/remove_offline_project?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createFavorite(project, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }

    let url = process.env.REACT_APP_API + '/projects/' + project.id + '/add_favorite?current_company=' + localStorage.current_company_id;
    
    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'post',
      url: url,
      data: {
        event_metadatum: eventMetadatum,
        favorite_id: project.id,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteFavorite(project_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/projects/' + project_id + '/remove_favorite?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createProjectCompany(company, project, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '/add_company?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        company: company,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteProjectCompany(company, project, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '/remove_company?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        company: company,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateCustomProjectSetting(projectSetting, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    delete projectSetting.toBeUpdated;
    delete projectSetting.toBeDeleted;
    return axios({
      method: 'patch',

      url: process.env.REACT_APP_API + '/projects/' + projectSetting.project_id + '/custom_project_settings/' + projectSetting.id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        custom_project_setting: projectSetting,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getCustomProjectSettings(project) {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '/custom_project_settings?current_company=' + localStorage.current_company_id,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getCustomProjectSetting(id) {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/projects/custom_project_settings/' + id + '?current_company=' + localStorage.current_company_id,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createCustomProjectSetting(projectSetting, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    delete projectSetting.toBeUpdated;
    delete projectSetting.toBeDeleted;
    projectSetting.field_required = false;
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/projects/' + projectSetting.project_id + '/custom_project_settings?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        custom_project_setting: projectSetting,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteCustomProjectSetting(projectSetting, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/projects/' + projectSetting.project_id + '/custom_project_settings/' + projectSetting.id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  addUserToProject(userId, project, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '/add_user?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: { id: userId },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  
  removeUserFromProject(userId, project, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '/remove_user?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: {  id: userId },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  replaceMember(project, newUser, oldUser, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: `${process.env.REACT_APP_API}/projects/${project.id}/replace_member?current_company=${localStorage.current_company_id}`,
      data: {
        event_metadatum: eventMetadatum,
        user_to_replace_id: oldUser.id,
        new_user_id: newUser.id,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  getProjectsSummary(company_id, filter, options) {
    let url = process.env.REACT_APP_API + '/warehouse/dim_project_currents/status_summary?current_company=' + (company_id ? company_id : localStorage.current_company_id);
    if (!miscFunctions.isEmpty(filter)) {
      url += '&state=' + (filter.state || '') + '&location=' + (filter.location ? filter.location.id : '');
      if (filter.project_managers) {
        // NOTE: axios does not seem to escape % characters (or rails
        // doesn't handle % by itself correctly) hence the replace
        let projectManagers = '&project_manager_name=' + filter.project_managers.map(pm => { return (pm.first_name + ' ' + pm.last_name);}).join(',').replace(/%/g, '%25'); 
        url += projectManagers;
      }
      if (filter.project_types) {
        let projectTypes = '&project_type_name=' + filter.project_types.map(pt => encodeURIComponent(pt.name)).join(',');
        url += projectTypes;
      }
      if (filter.showArchived) {
        url += '&include_archived=true';
      }

      if (filter.projectEventType && (filter.startDate || filter.endDate)) {
        let sDate = new Date(filter.startDate).toUTCString();
        let eDate = new Date(filter.endDate).toUTCString();

        let utcStart = Date.parse(sDate);
        let utcEnd = Date.parse(eDate);
        utcEnd += 24 * 60 * 60 * 1000 - 1;

        let offset = (new Date().getTimezoneOffset() * 60 * 1000);

        utcStart += offset;
        utcEnd += offset;

        url += filter.startDate ? `&start_date=${Math.floor(utcStart / 1000)}` : '';
        url += filter.endDate ? `&end_date=${Math.floor(utcEnd / 1000)}` : '';

        url += '&date_column=' + (filter.projectEventType == 'completed' ? 'completed_dtm' : 'create_dtm');
      }

      if (filter.statuses) {
        let statuses = filter.statuses.map(status => {
          switch (status) {
          case 'not_started':
            return 'Not Started';
          case 'in_progress':
            return 'In Progress';
          case 'complete':
            return 'Complete';
          default:
            return '';
          }
        });
        url += '&status=' + statuses.join(',');
      }
    }
    if (options.marketIds) {
      url += '&markets=' + options.marketIds.join(',');
    }

    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });

  },
  search(searchString, filter = null, archivedOnly = false, sortField = null, user_id, page, perPage, company_id, noFavorites, includeArchived, ungrouped, options) {
    
    let url = process.env.REACT_APP_API + '/projects/search_and_filter?current_company=' +
      (company_id ? company_id : localStorage.current_company_id) + '&keywords=' + (searchString || '') + (user_id ? '&user=' + user_id : '') + (noFavorites ? '&no_favorites=true' : '');
    
    if (!miscFunctions.isEmpty(filter)) {
      url += '&state=' + (filter.state || '') + '&location=' + (filter.location ? filter.location.id : '');
      if (filter.project_managers) {
        let projectManagers = '&project_managers=' + filter.project_managers.map(pm => { return pm.id ? pm.id : pm; }).join(',');
        url += projectManagers;
      }
      if (filter.project_types) {
        let projectTypes = '&project_types=' + filter.project_types.map(pt => { return (pt.id);}).join(',');
        url += projectTypes;
      }
      else if (filter.projectTypeId) {
        let projectTypes = '&project_types=' + filter.projectTypeId;
        url += projectTypes;
      }
      if (filter.statuses) {
        let statuses = '&status=' + filter.statuses.join(',');
        url += statuses;
      }
      if (filter.contractIds) {
        let contract_ids = '&contract_ids=' + filter.contractIds.join(',');
        url += contract_ids;
      }
    }
    if (filter && filter.projectEventType && (filter.startDate || filter.endDate)) {
      let sDate = new Date(filter.startDate).toUTCString();
      let eDate = new Date(filter.endDate).toUTCString();

      let utcStart = Date.parse(sDate);
      let utcEnd = Date.parse(eDate);
      utcEnd += 24 * 60 * 60 * 1000 - 1;

      let offset = (new Date().getTimezoneOffset() * 60 * 1000);

      utcStart += offset;
      utcEnd += offset;

      url += filter.startDate ? `&start_date=${Math.floor(utcStart / 1000)}` : '';
      url += filter.endDate ? `&end_date=${Math.floor(utcEnd / 1000)}` : '';

      url += '&date_column=' + (filter.projectEventType == 'completed' ? 'completed_at' : 'created_at');
    }
    if (sortField && sortField.fieldName) {
      url += '&order=' + sortField.fieldName + (sortField.ascending ? ',asc' : ',desc');
    }
    if (page && perPage) {
      url += '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }
    url += (archivedOnly || (filter && filter.status == 'archived') ? '&archived=true' : '') + (includeArchived ? '&include_archived=true' : '');
    
    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    if (options && options.marketIds) {
      url += '&markets=' + options.marketIds.join(',');
    }
    if(ungrouped){
      url += '&ungrouped=' + ungrouped;
    }
    if (options && options.for_picker) {
      url += '&for_picker=true';
    }

    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  searchProjectReport(searchString, filter = null, archivedOnly = false, sortField = null, ascending=false, user_id, page, perPage, company_id, noFavorites, includeArchived, options) {
    let url = process.env.REACT_APP_API + '/projects/search_and_filter_project_report?current_company=' +
      (company_id ? company_id : localStorage.current_company_id) + '&keywords=' + (searchString || '') + (user_id ? '&user=' + user_id : '') + (noFavorites ? '&no_favorites=true' : '');
    
    if (!miscFunctions.isEmpty(filter)) {
      url += '&state=' + (filter.state || '') + '&location=' + (filter.location ? filter.location.id : '');
      if (filter.project_managers) {
        let projectManagers = '&project_managers=' + filter.project_managers.map(pm => { return pm.id ? pm.id : pm; }).join(',');
        url += projectManagers;
      }
      if (filter.project_types) {
        let projectTypes = '&project_types=' + filter.project_types.map(pt => { return (pt.id);}).join(',');
        url += projectTypes;
      }
      else if (filter.projectTypeId) {
        let projectTypes = '&project_types=' + filter.projectTypeId;
        url += projectTypes;
      }
      if (filter.statuses) {
        let statuses = '&status=' + filter.statuses.join(',');
        url += statuses;
      }
      if (filter.contractIds) {
        let contract_ids = '&contract_ids=' + filter.contractIds.join(',');
        url += contract_ids;
      }
    }
    if (sortField) {
      url += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }
    if (page) {
      url += '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }
    if (options.marketIds) {
      url += '&markets=' + options.marketIds.join(',');
    }

    if (filter.projectEventType && (filter.startDate || filter.endDate)) {
      let sDate = new Date(filter.startDate).toUTCString();
      let eDate = new Date(filter.endDate).toUTCString();

      let utcStart = Date.parse(sDate);
      let utcEnd = Date.parse(eDate);
      utcEnd += 24 * 60 * 60 * 1000 - 1;

      let offset = (new Date().getTimezoneOffset() * 60 * 1000);

      utcStart += offset;
      utcEnd += offset;

      url += filter.startDate ? `&start_date=${Math.floor(utcStart / 1000)}` : '';
      url += filter.endDate ? `&end_date=${Math.floor(utcEnd / 1000)}` : '';

      url += '&date_column=' + (filter.projectEventType == 'completed' ? 'completed_at' : 'created_at');
    }

    url += (archivedOnly || (filter && filter.status == 'archived') ? '&archived=true' : '') + (includeArchived ? '&include_archived=true' : '');
    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  search_location_projects(searchString, project_type_id = '', state = '', locationID = '', sortField = '', statuses, showArchived = false, ascending, page, perPage, options) {
    let url = process.env.REACT_APP_API + '/projects/search_and_filter_location_projects?current_company=' + localStorage.current_company_id +
    (searchString ? '&keywords=' + searchString : '') + (project_type_id ?'&project_type=' + project_type_id : '') +
    (state ? '&state=' + state : '') + (locationID ? '&location=' + locationID : '') + (showArchived ? '&archived=true' : '');
    if (statuses) {
      url += '&status=' + statuses.join(',');
    }
    if (sortField) {
      url += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }
    if (page) {
      url += '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }
    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  searchMyProjects(searchString, sortField, ascending=true, filters, page, perPage, noFavorites, options) {
    let is_offline_project=false;
    let url = process.env.REACT_APP_API + '/projects/all_assigned_projects?current_company=' +
      localStorage.current_company_id + (searchString ? '&keywords=' + searchString : '') + (noFavorites ? '&no_favorites=true' : '');
    if (sortField) {
      url += '&order=' + sortField + (ascending ? ',asc' : ',desc');
    }
    if (page) {
      url += '&page=' + page + '&per=' + (perPage ? perPage : 7);
    }
    if(filters.statuses){
      for(const status of filters.statuses){
        if(status =='offline'){
          is_offline_project=true;
        }
      }
    }
    filters = filters || {};
    url += (filters.state ? '&state=' + filters.state : ''); 
    url += (filters.projectTypeId ? '&project_type=' + filters.projectTypeId : '');
    url += (filters.showArchived ? '&archived=true' : '');
    url += (filters.statuses ? '&status=' + filters.statuses.filter(function(status) { return status!='offline';}).join(',') : '');
    if(filters.markets){
      filters.markets.forEach(market => {
        url += '&market[]=' + market;
      });
    }
    url += (filters.statuses ? '&status=' + filters.statuses.filter(function(status) { return status!='offline';}).join(',') : '');
    url += (is_offline_project ? '&offline_projects=true' : '');
    if (options && options.recordDescriptor) {
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'get',
      url: url,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        let data=response.data;
        localStorage.setItem('favorite_projects',data.meta.total_favorite_projects);
        localStorage.setItem('total_projects',data.meta.total_projects);
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createNotify(project, notify, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    delete project.toBeAdded;
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '/notify?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: {  id: notify.user.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteNotify(project, notify, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    delete project.toBeDeleted;
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '/remove_notify?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        user: {  id: notify.user.id },
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  migrateProjectProjectTemplate(project, project_template, eventMetadatum, deleteNotUsed = false) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }

    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '/project_templates/' + (project_template ? project_template.id : -1) + '/migrate?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        delete_not_used: 'true',
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        DataModel.displayInfoErrorMessage(error.response.data.error, 4000);
      });
  },
  removeProjectTemplate(project, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/projects/' + project.id + '/remove_project_template?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  addUniqueDocument(projectId, documentId, documentObject, options, eventMetadatum) {
    let data = new FormData();
    data.append('name', documentObject.name);
    data.append('attachment', documentObject.attachment);
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    data.append('event_metadatum', JSON.stringify(eventMetadatum));
    if (documentId) {
      data.unique_document_id = documentId;
    }

    let url = process.env.REACT_APP_API + '/projects/' + projectId + '/add_unique_document?current_company=' + localStorage.current_company_id;
    if (options && options.recordDescriptor) {
      //added this for now so we can descriminate between old and new calls
      url +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'post',
      url,
      data,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },

  removeUniqueDocument(projectId, documentId,  eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }

    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/projects/' + projectId + '/remove_unique_document?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        unique_document_id: documentId,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },

  removeReferenceDocument(projectId, documentId,  eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }

    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/projects/' + projectId + '/remove_reference_document?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        reference_document_id: documentId,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },

  countUserAssignments(project_id, user_id) {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/projects/' + project_id + '/count_user_task_assignments?current_company=' + localStorage.current_company_id + '&user_id='  + user_id,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  createProjectContact(projectContact, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/projects/' +
        projectContact.project_id +
        '/add_contact' +
        '?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        project_contact: {  
          title: projectContact.title,
          user_id: projectContact.user.id,
        },
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateProjectContact(projectContact, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url:
        process.env.REACT_APP_API +
        '/projects/' +
        projectContact.project_id +
        '/update_contact?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        project_contact: {  
          id: projectContact.id,
          title: projectContact.title,
          user_id: projectContact.user.id,
        },
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteProjectContact(projectId, projectContactId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url:
      process.env.REACT_APP_API +
      '/projects/' +
      projectId +
      '/remove_contact/?current_company=' +
      localStorage.current_company_id,
      timeout: 20000,
      data: {
        event_metadatum: eventMetadatum,
        project_contact_id: projectContactId,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;




// WEBPACK FOOTER //
// ./src/services/projectsService.js